import { useTheme } from '../hooks/useTheme';
import { Theme } from '../state/theme';
import { useContainerComponent } from '../video-sdk/actions/useComponentActions';
import { StageContainer, StageContainerProps } from './StageContainer';

export function StageContainerWrapper(props: Omit<StageContainerProps, 'isDarkTheme' | 'videoContainerComponent'>) {
  const { theme } = useTheme();
  const VideoContainer = useContainerComponent();

  return <StageContainer {...props} isDarkTheme={theme === Theme.DARK} videoContainerComponent={VideoContainer} />;
}
